import { h, render } from 'preact';
// import AudioPlayer from './utils/audio-player';
import debounce from './utils/debounce';
import select from './utils/select';
import selectAll from './utils/select-all';
import RelatedStories from './components/related-stories';
import Swiper from 'swiper';

import Player from './components/player';

import javier from '../assets/transcripts/javier.json';
import karen from '../assets/transcripts/karen.json';
import nancy from '../assets/transcripts/nancy.json';
import neiva from '../assets/transcripts/neiva.json';
import uzair from '../assets/transcripts/uzair.json';

const transcripts = { javier, karen, nancy, neiva, uzair };

const mainContainer = select('.main-container');
const slides = selectAll('.swiper-slide');
// const player = new AudioPlayer({ initSlug: 'neiva' });
const player = new Player('assets/audio/{{id}}.{{ext}}');
const audioControl = select('#audio-control');
const playingControl = select('#playing-control');
const relatedStories = select('#related-stories-container');
const nextButton = select('#next-button');
const nextButtonIcon = select('.icon', nextButton);
const nextButtonText = select('.js-next-button-text', nextButton);
const prevButton = select('#prev-button');
const replayButton = select('#replay-button');

const slideTranscript = select('#slide-transcript');
const transcriptElement = select('span', slideTranscript);

const navigator = window.navigator;
const isMobile =
  /Android/i.test(navigator.userAgent) ||
  /iPhone|iPad|iPod/i.test(navigator.userAgent);

// state
let animationTimeout = null;
let relatedStoriesLoaded = false;
let currentTranscript = null;

// event tracking
const eventPercents = [10, 25, 50, 75, 90, 100];
const absoluteEventCache = {};
const percentEventCache = {};

function toggleAudioSvgs(state) {
  // first turn them all off
  selectAll('svg', audioControl).forEach(svg => svg.classList.add('hidden'));

  if (state === 'playing')
    audioControl.querySelector('.audio-playing').classList.remove('hidden');
  if (state === 'muted')
    audioControl.querySelector('.audio-muted').classList.remove('hidden');
}

function togglePlayingSvgs(state) {
  // first turn them all off
  selectAll('svg', playingControl).forEach(svg => svg.classList.add('hidden'));

  if (state === 'paused')
    playingControl.querySelector('.audio-pause').classList.remove('hidden');
  if (state === 'play')
    playingControl.querySelector('.audio-play').classList.remove('hidden');
  if (state === 'restart')
    playingControl.querySelector('.audio-restart').classList.remove('hidden');
}

const swiper = new Swiper('.swiper-container', {
  pagination: '.swiper-pagination',
  direction: 'vertical',
  speed: 600,
  slidesPerView: 1,
  mousewheelControl: true,
  keyboardControl: true,
  // Disable preloading of all images
  preloadImages: false,
  // Enable lazy loading
  lazyLoading: true,
  lazyLoadingInPrevNext: true,

  effect: 'fade',
  fade: {
    crossFade: false,
  },

  nextButton: '#next-button',
  prevButton: '#prev-button',
});

if (isMobile) {
  slides.forEach(slide => slide.classList.add('swiper-no-swiping'));
  swiper.disableTouchControl();
}

swiper.on('onInit', instance => {
  const activeIndex = instance.activeIndex;
  const normalizedIndex = activeIndex + 1;

  if (!absoluteEventCache[normalizedIndex]) {
    absoluteEventCache[normalizedIndex] = true;

    ga('send', {
      hitType: 'event',
      eventCategory: 'Interactive',
      eventAction: 'Absolute - Slide Depth',
      eventLabel: normalizedIndex,
    });
  }
});

swiper.on('onSlideChangeStart', instance => {
  const activeIndex = instance.activeIndex;
  const activeSlide = instance.slides[activeIndex];
  const audioSlug = activeSlide.getAttribute('data-audio-slug');

  transcriptElement.textContent = '';

  if (!audioSlug) {
    player.stop();
    playingControl.classList.add('hidden');
    return;
  }
  playingControl.classList.remove('hidden');

  currentTranscript = transcripts[audioSlug];
  player.play(audioSlug);
});

swiper.on('onSlideChangeEnd', instance => {
  const activeIndex = instance.activeIndex;
  const normalizedIndex = activeIndex + 1;
  const numSlides = instance.slides.length;
  const activeSlide = instance.slides[activeIndex];
  const audioSlug = activeSlide.getAttribute('data-audio-slug');

  if (!audioSlug) transcriptElement.textContent = '';

  if (activeIndex + 1 >= instance.slides.length - 1 && !relatedStoriesLoaded) {
    loadRelatedStories();
  }

  if (activeIndex > 0 && !instance.isEnd) {
    nextButtonText.textContent = 'Next';
    nextButtonIcon.classList.remove('icon--animated');
    nextButton.classList.remove('hidden');
    prevButton.classList.remove('hidden');
    replayButton.classList.add('hidden');

    if (animationTimeout) window.clearTimeout(animationTimeout);
  }

  // events
  if (!absoluteEventCache[normalizedIndex]) {
    absoluteEventCache[normalizedIndex] = true;

    ga('send', {
      hitType: 'event',
      eventCategory: 'Data Visuals - Slider',
      eventAction: 'Absolute - Slide Depth',
      eventLabel: `${normalizedIndex}/${numSlides}`,
      eventValue: normalizedIndex,
    });
  }

  const percentComplete = normalizedIndex / numSlides * 100;

  eventPercents.forEach(p => {
    if (percentComplete >= p && !percentEventCache[p]) {
      percentEventCache[p] = true;

      ga('send', {
        hitType: 'event',
        eventCategory: 'Data Visuals - Slider',
        eventAction: 'Percent - Slide Depth',
        eventLabel: `${p}%`,
        eventValue: p,
      });
    }
  });
});

swiper.on('reachBeginning', () => {
  player.stop();
  nextButtonText.textContent = 'Begin';
  nextButtonIcon.classList.add('icon--animated');
  nextButton.classList.remove('hidden');
  prevButton.classList.add('hidden');
});

swiper.on('reachEnd', () => {
  player.stop();
  nextButton.classList.add('hidden');
  replayButton.classList.remove('hidden');
});

player.on('play', obj => {
  if (player.isMuted) {
    toggleAudioSvgs('muted');
  } else {
    toggleAudioSvgs('playing');
  }

  togglePlayingSvgs('paused');

  ga('send', {
    hitType: 'event',
    eventCategory: 'Data Visuals - Audio',
    eventAction: 'play',
    eventLabel: obj.id,
    eventValue: Math.round(obj.currentSound.percentComplete),
  });
});

player.on('stopped', () => {
  transcriptElement.textContent = '';
});

player.on('ended', obj => {
  setTimeout(() => (transcriptElement.textContent = ''), 2000);
  togglePlayingSvgs('restart');

  animationTimeout = setTimeout(() => {
    nextButtonIcon.classList.add('icon--animated');
  }, 1000 * 10);

  ga('send', {
    hitType: 'event',
    eventCategory: 'Data Visuals - Audio',
    eventAction: 'ended',
    eventLabel: obj.id,
    eventValue: 100,
  });
});

player.on('tick', ({ position }) => {
  let activeText = '';

  for (let i = 0; i < currentTranscript.length; i++) {
    const entry = currentTranscript[i];

    if (position < entry.start) {
      if (i > 0) {
        activeText = currentTranscript[i - 1].text;
      } else {
        activeText = entry.text;
      }
      break;
    } else {
      activeText = entry.text;
    }
  }

  if (activeText.length !== 0) {
    transcriptElement.textContent = activeText;
  }
});

player.on('restart', obj => {
  nextButtonIcon.classList.remove('icon--animated');

  ga('send', {
    hitType: 'event',
    eventCategory: 'Data Visuals - Audio',
    eventAction: 'replay',
    eventLabel: obj.id,
    eventValue: Math.round(obj.currentSound.percentComplete),
  });
});

player.on('pause', obj => {
  togglePlayingSvgs('play');
});

player.on('mute', () => {
  toggleAudioSvgs('muted');

  ga('send', {
    hitType: 'event',
    eventCategory: 'Data Visuals - Audio',
    eventAction: 'mute',
  });
});

player.on('unmute', () => {
  toggleAudioSvgs('playing');

  ga('send', {
    hitType: 'event',
    eventCategory: 'Data Visuals - Audio',
    eventAction: 'unmute',
  });
});

audioControl.addEventListener('click', () => {
  if (player.isMuted) {
    player.unmute();
  } else {
    player.mute();
  }
});

playingControl.addEventListener('click', () => {
  if (player.isPlaying) {
    player.pause();
    togglePlayingSvgs('play');
  } else if (!player.isPlaying && !player.isDone) {
    player.play();
    togglePlayingSvgs('paused');
  } else if (player.isDone) {
    player.restart();
    togglePlayingSvgs('paused');
  }
});

function loadRelatedStories() {
  const url =
    'https://www.texastribune.org/api/v1/content/?content_type=story,audio,video,pointer&amp;tag=subject-dream-act&amp;tag!=object-tribcast&amp;fields=id,url,readable_pub_date,seo_headline,short_summary,lead_art&amp;limit=4&amp;format=json';

  render(
    <RelatedStories src={url} numStories={isMobile ? 1 : 2} isColumn />,
    relatedStories
  );

  relatedStoriesLoaded = true;
}

replayButton.addEventListener('click', () => {
  nextButtonText.textContent = 'Begin';
  nextButton.classList.remove('hidden');
  replayButton.classList.add('hidden');

  swiper.slideTo(0, 0);
});

window.addEventListener('orientationchange', debounce(onResize, 300), {
  passive: true,
});

function onResize() {
  const windowHeight = window.innerHeight;
  mainContainer.style['max-height'] = `${Math.min(
    windowHeight,
    document.documentElement.clientHeight
  )}px`;

  for (let i = 0; i < slides.length; i++) {
    slides[i].style['max-height'] = `${windowHeight}px`;
  }

  swiper.update(true);
}

export default () => null;



// WEBPACK FOOTER //
// ./main.js